import { Controller } from "@hotwired/stimulus"

// AI Composer form helpers (#636): reveal the free-text "Other" inputs when the
// role/tone selects include the "other" sentinel, and cap tone selection at a
// maximum (3 by default, mirroring the legacy composer).
export default class extends Controller {
  static targets = ["role", "roleOther", "tones", "toneOther", "generateImage", "imagePrompt"]
  static values = { maxTones: { type: Number, default: 3 } }

  connect() {
    this.toggleRoleOther()
    this.toggleToneOther()
    this.toggleImagePrompt()
  }

  toggleImagePrompt() {
    if (!this.hasImagePromptTarget || !this.hasGenerateImageTarget) return
    this.imagePromptTarget.hidden = !this.generateImageTarget.checked
  }

  toggleRoleOther() {
    if (!this.hasRoleOtherTarget || !this.hasRoleTarget) return
    this.roleOtherTarget.hidden = this.roleTarget.value !== "other"
  }

  toggleToneOther() {
    if (!this.hasToneOtherTarget) return
    this.toneOtherTarget.hidden = !this.selectedTones().includes("other")
  }

  // Undo the most recent selection once the cap is exceeded, then resync the
  // "Other" reveal.
  limitTones() {
    if (!this.hasTonesTarget) return

    const options = Array.from(this.tonesTarget.selectedOptions)
    if (options.length > this.maxTonesValue) {
      options[options.length - 1].selected = false
      window.alert(`You can select up to ${this.maxTonesValue} tones.`)
    }
    this.toggleToneOther()
  }

  selectedTones() {
    if (!this.hasTonesTarget) return []
    return Array.from(this.tonesTarget.selectedOptions).map((option) => option.value)
  }
}
